import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import metEmployedImg from '../Assets/maxresdefault.webp'
import Printer from '../Assets/3D-Printer.webp'
import unity from '../Assets/unityexploreworld.png'
import worldtreeSweeper from '../Assets/Screenshot_2024-04-04_190807.webp'
import dinoNFT from '../Assets/dinonft.png'
import vireel from '../Assets/Vireel.png'
import inclusee from '../Assets/original.jpeg'
import landTempAnalyze from '../Assets/30-april-BLOG.jpg'
import beted from '../Assets/gallery.jpg'
import vhdl from '../Assets/FPGA-Board.jpg'
import weatherApp from '../Assets/weatherapp.png'
import bookapp from '../Assets/bookapp.png'

// Project data with tags
const projectsData = [
  {
    img: metEmployedImg,
    title: 'MetEmployed - EduSands Hacks Winner',
    description: 'Tackling social equity by providing the less fortunate with the same opportunities. This project was geared towards addressing a real-world societal problem. I worked on the front-end as well as some back-end.',
    link: 'https://devpost.com/software/soluhacks',
    tags: ['React', 'Node.js', 'JavaScript', 'Tailwind CSS']
  },
  {
    img: Printer,
    title: 'BioSafe3D',
    description: 'The goal was to increase the efficiency of 3D printers while simultaneously making them more affordable, eco-friendly, user-friendly, and efficient. One of our groups aims is to improve the printing process.',
    link: 'https://www.linkedin.com/in/syed-kaab-surkhi/details/projects/1725677988584/single-media-viewer/?profileId=ACoAADw7DekBf3zuNXNi6JV7W3xczKhJaG8_5OA',
    tags: ['CAD', '3D Printing', 'Re-Engineering', 'Project Management', 'Research']
  },
  {
    img: unity,
    title: 'ExploreWorld-Unity',
    description: 'This project is a world exploration game that includes real world physics to control objects such as vehicles in a fun and interesting way. Developments are ongoing.',
    link: 'https://github.com/SurkhiSyed/Final-ExploreWorld',
    tags: ['Unity', 'C#', 'Game Development', 'Physics-Engine']
  },
  {
    img: worldtreeSweeper,
    title: 'WorldTreeSweeper - Unity',
    description: 'This game was created using the Unity Game Engine with a solo-type RPG in mind, with the task of controlling the avatar through challenging terrain and difficult enemies. Real world physics that learned in Grade 11 and 12 was taken into consideration and different principles were applied.',
    link: 'https://github.com/SurkhiSyed/WorldTreeSweeper-Unity?tab=readme-ov-file',
    tags: ['Unity', 'C#', 'Game Development', 'RPG']
  },
  {
    img: dinoNFT,
    title: 'DinoNFT - HawkHacks 3rd Place Winner',
    description: 'DinoNFT is a simple web3 dino running game, similar to that of the google offline game. It incorporates a reward system for the player based on their score by allowing them to connect their blockchain wallet to the game, and transfer tokens from the owner\'s wallet to theirs.',
    link: 'https://github.com/SurkhiSyed/Hack',
    tags: ['Web3', 'Blockchain', 'JavaScript', 'Game Development']
  },
  {
    img: inclusee,
    title: 'Inclusee',
    description: 'Inclusee is an accessibility addon for Adobe Express that helps designers ensure their creations are accessible to individuals with low vision, dyslexia, and other visual impairments. Incorporating real-time feedback and suggestions by analyzing colors, fonts, and layouts used in design.',
    link: 'https://devpost.com/software/inclusee',
    tags: ['Adobe API', 'JavaScript', 'Accessibility', 'UX/UI', 'React']
  },
  {
    img: vireel,
    title: 'Vireel - Startup',
    description: 'Vireel is currently a news app that aggregates content from multiple APIs to deliver news in a concise and user-friendly format, allowing users to receive quick summaries tailored to their interests, save their favorite stories, share comments, and engage in discussions instead of sifting through long articles as it expands into a startup.',
    link: 'https://github.com/SurkhiSyed/Vireel',
    tags: ['Full Stack', 'React', 'Node.js', 'API Integration', 'JavaScript', 'Tailwind CSS', 'Flask', 'Firebase', 'Python', 'Gemini API']
  },
  {
    img: landTempAnalyze,
    title: 'Average Land Temperatures Analyzer',
    description: 'Developed a C program that studies different average land temperatures over 3 centuries using CSV files and outputs different averages. Used GNU Plots to create different plots in respect to the outputted data to evaluate trends and report conclusions.',
    link: 'https://github.com/SurkhiSyed/LandAverageTemperatures',
    tags: ['C', 'Data Analysis', 'GNU Plot', 'CSV Processing']
  },
  {
    img: bookapp,
    title: 'BookCartFX',
    description: 'Developed a Bookstore application in JavaFX, implementing secure user authentication and real-time book management functionalities. Collaborated in a team to design and implement system architecture using UML modeling and design patterns, ensuring scalability.',
    link: 'https://github.com/SurkhiSyed/BookCartFX',
    tags: ['Java', 'JavaFX', 'FXML', 'UML Modeling', 'Object-Oriented Programming', 'Design Patterns', 'JavaGUI']
  },
  {
    img: vhdl,
    title: 'Simple-Central-Processing-Unit',
    description: 'Created a multi-functional CPU in a VHDL environment developed on an FPGA board using various inputs and outputs and programmed using VHDL on Altera Quartus. Implemented different functionalities using FSM state machine, latches, decoders, 7 segment converters, and arithmetic and logic units (ALU cores). Simulated CPU using block schematics and logic waveforms.',
    link: 'https://github.com/SurkhiSyed/Simple-Central-Processing-Unit',
    tags: ['VHDL', 'FPGA', 'FSM', 'ALU', 'Decoder', '7 Segment Converter', 'CPU', 'Quartus', 'Logic System Design']
  },
  {
    img: weatherApp,
    title: 'Weather-App',
    description: 'Developed a weather app using React, OpenWeatherMap API, and Tailwind CSS. The app allows users to search for weather information by city name and displays current weather conditions, temperature, and forecast for the next 3 days. With CRUD functionality, the backend allows users to add, edit, and delete weather information from mySQL database.',
    link: 'https://github.com/SurkhiSyed/WeatherChallenge',
    tags: ['React', 'OpenWeatherMap API', 'Tailwind CSS', 'MySQL', 'Node.js', 'Express', 'JavaScript', 'Full Stack', 'REST API', 'CRUD']
  },
  {
    img: beted,
    title: 'BetEd',
    description: 'A networking platform for inexperienced tech seekers to collaborate on challenging competitions while being tutored by a trained learning model and receiving feedback from professionals. Implemented Retrieval Augmented Generation (RAG) for training an AI model with the use of Snowflake database, Mistral LLM for generation, and Cortex Search for retrieval.',
    link: 'https://github.com/SurkhiSyed/beted',
    tags: ['Streamlit', 'Python', 'Retrieval-Augmented-Generation', 'TailWind CSS', 'Firebase', 'Snowflake', 'JavaScript', 'Web Scraping', 'Full Stack', 'Mistral LLM', 'Cortex']
  }
];

// Extract unique tags from all projects
const allTags = [...new Set(projectsData.flatMap(project => project.tags))].sort();

const Projects = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);

  // Handle tag selection
  const toggleTag = (tag) => {
    setSelectedTags(prev => 
      prev.includes(tag) 
        ? prev.filter(t => t !== tag)
        : [...prev, tag]
    );
  };

  // Filter projects based on search term and selected tags
  const filteredProjects = projectsData.filter(project => {
    const matchesSearch = project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesTags = selectedTags.length === 0 || 
                       selectedTags.every(tag => project.tags.includes(tag));
    
    return matchesSearch && matchesTags;
  });

  // Clear all filters
  const clearFilters = () => {
    setSearchTerm('');
    setSelectedTags([]);
  };

  return (
    <div className='w-full py-[10rem] px-4'>
        <h1 className='text-7xl font-bold text-[#00d59a] text-center'>Projects</h1>
      
      {/* Search and Filter Section */}
      <div className='max-w-[1240px] mx-auto mt-8 mb-12'>
        {/* Search Bar */}
        <div className='relative mb-6'>
          <input
            type="text"
            placeholder="Search projects..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='w-full px-4 py-2 rounded-lg bg-[#386e4f80] text-white placeholder-gray-300 border border-[#00d59a] focus:outline-none focus:ring-2 focus:ring-[#00d59a]'
          />
                </div>

        {/* Tags Filter */}
        <div className='mb-6'>
          <div className='flex flex-wrap gap-2'>
            {allTags.map((tag) => (
              <button
                key={tag}
                onClick={() => toggleTag(tag)}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-colors duration-200 ${
                  selectedTags.includes(tag)
                    ? 'bg-[#00d59a] text-black'
                    : 'bg-[#386e4f80] text-white border border-[#00d59a] hover:bg-[#00d59a] hover:text-black'
                }`}
              >
                {tag}
                </button>
            ))}
            {(selectedTags.length > 0 || searchTerm) && (
              <button
                onClick={clearFilters}
                className='px-3 py-1 rounded-full text-sm font-medium bg-red-500 text-white hover:bg-red-600 transition-colors duration-200'
              >
                Clear Filters
                </button>
            )}
            </div>
                </div>

        {/* No Results Message */}
        {filteredProjects.length === 0 && (
          <div className='text-center text-white py-8'>
            No projects match your search criteria.
            </div>
        )}
                </div>

      {/* Projects Grid */}
      <div className='max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8'>
        {filteredProjects.map((project, index) => (
          <div key={index} className='w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300 bg-[#386e4f80]'>
            <img className='w-80 mx-auto bg-white rounded-lg' src={project.img} alt='/'/>
            <p className='text-center text-1xl font-bold text-white my-6'>{project.title}</p>
                <div className='text-center font-medium'>
              <p className='py-1 text-white mx-8 mt-2'>{project.description}</p>
                </div>
            {/* Tags section */}
            <div className='flex flex-wrap justify-center gap-2 mt-4 mb-4'>
              {project.tags.map((tag, tagIndex) => (
                <span 
                  key={tagIndex} 
                  className='px-3 py-1 text-sm bg-[#00d59a] text-black rounded-full font-medium cursor-pointer hover:bg-[#00b481] transition-colors duration-200'
                  onClick={() => toggleTag(tag)}
                >
                  {tag}
                </span>
              ))}
                </div>
                <button className='bg-[#ffffff] w-[200px] rounded-md font-medium mx-auto my-6 px-6 py-3'>
              <Link to={project.link} target='_blank' rel='noopener noreferrer'>Click Here</Link>
                </button>
            </div>
        ))}
        </div>
    </div>
  )
}

export default Projects